<template>
  <div class="main-container">
    <div class="container">
      <iframe :src="frameSrc" title="観測データ表示"></iframe>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
const frameSrc = computed(() => `${import.meta.env.BASE_URL}sensor/obs.html`)
</script>
